import { render } from "./std-page-layout.html?vue&type=template&id=0b72f6b8&scoped=true&ts=true&external"
import script from "./std-page-layout.ts?vue&type=script&lang=ts&external"
export * from "./std-page-layout.ts?vue&type=script&lang=ts&external"

import "./std-page-layout.scss?vue&type=style&index=0&id=0b72f6b8&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b72f6b8"]])

export default __exports__